import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";

const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title = "Confirm",
  description = "",
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmColor = "primary",
  confirmIcon = null,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={"xs"}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          px: 2,
          py: 1.5,
          boxShadow: "0px 10px 30px rgba(0,0,0,0.15)",
        },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          fontSize: "1.25rem",
          fontWeight: 600,
          pb: 0.5,
        }}
      >
        {title}
      </DialogTitle>

      <DialogContent>
        <Box sx={{ textAlign: "center", mt: 1 }}>
          <Typography variant="body1" color="text.secondary">
            {description}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          gap: 2,
          px: 3,
          pb: 3,
          pt: 2,
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          color="inherit"
          sx={{
            minWidth: 120,
            borderRadius: 2,
            textTransform: "none",
          }}
        >
          {cancelText}
        </Button>

        <Button
          onClick={onConfirm}
          variant="contained"
          color={confirmColor}
          startIcon={confirmIcon}
          sx={{
            minWidth: 120,
            borderRadius: 2,
            textTransform: "none",
            boxShadow: "none",
            "&:hover": {
              boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
            },
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
